import { format } from 'date-fns';
import { enUS, de } from 'date-fns/locale';
import moment from 'moment';

const handleDateInput = (type, value) => {
    let formattedDate = null;
    

    try {
        if (type === 'datetime-local' && value && value !== '') {
            formattedDate = formatDateTime(value);
        } else if (type === 'datetime' && value && value !== '') {
            formattedDate = formatDateTime(value-60);
        } else if (type === 'date' && value && value !== '') {
            formattedDate = formatDate(value);
        }
    } catch (error) {
        console.error('An error occurred:', error.message, value);
        formattedDate = getDefaultDate(type);
    }

    return formattedDate;
};

function isAtLeastMinutesInFuture(scheduledTime, minutes) {
    try {
        const scheduledDate = new Date(scheduledTime);
        
        if (isNaN(scheduledDate)) {
            throw new Error("Invalid date format. Please provide a valid ISO 8601 date string.");
        }
        
        const currentTime = new Date();
        const futureTime = new Date(currentTime.getTime() + minutes * 60 * 1000);
        
        return scheduledDate >= futureTime;
    } catch (error) {
        console.error(error.message);
        return false;
    }
}

const formatDateForBackend = (dateString) => {
    try{
        const date = new Date(dateString);
        return date.toISOString();//toUTCString();
    } catch (error) {
        throw error;
    }
};

// Function to format datetime using moment
const formatDateTime = (value) => {
    const date = moment(value);
    if (!date.isValid()) {
        throw new Error('Invalid datetime format');
    }
    return date.format('YYYY-MM-DD HH:mm'); // Format to include date and time
};

// Function to format date using moment
const formatDate = (value) => {
    const date = moment(value);
    if (!date.isValid()) {
        throw new Error('Invalid date format');
    }
    return date.format('YYYY-MM-DD'); // Format to include only date
};

// Function to provide default date based on the type
const getDefaultDate = (type) => {
    const currentDate = moment(); // Current date and time
    if (type === 'datetime') {
        return currentDate.format('YYYY-MM-DD HH:mm');
    } else if (type === 'date') {
        return currentDate.format('YYYY-MM-DD');
    }
    // If no specific type matches, return a reasonable fallback or null
    return null;
};



function timeAgo(dateString) {
    const lastActivityDate = moment(dateString)//, "ddd, DD MMM YYYY HH:mm:ss z");
    const now = moment();
    const diff = now.diff(lastActivityDate, 'seconds');

    if (diff > 24 * 60 * 60) {
        const days = Math.floor(diff / (24 * 60 * 60));
        return `${days} day${days > 1 ? 's' : ''} ago`;
    } else if (diff > 60 * 60) {
        const hours = Math.floor(diff / (60 * 60));
        return `${hours} hour${hours > 1 ? 's' : ''} ago`;
    } else if (diff > 60) {
        const minutes = Math.floor(diff / 60);
        return `${minutes} minute${minutes > 1 ? 's' : ''} ago`;
    } else {
        return 'Just now';
    }
  }

const GMTtoCET = (gmtDateString) => {
    const date = new Date(gmtDateString);
    const formattedDate = date.toLocaleString('en-GB', {
        timeZone: 'Europe/Berlin', // This handles both CET and CEST appropriately
        weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
        hour: '2-digit', minute: '2-digit', second: '2-digit'
    });

    return formattedDate;
};

const FormatCET = (cetDateString, showTime=true) => {
    const date = new Date(cetDateString);
    const formattedDate = showTime ?
        date.toLocaleString('de-DE', {
            timeZone: 'Europe/Berlin',
            weekday: 'short', day: 'numeric', month: 'short', year: 'numeric',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        }) 
        : 
        date.toLocaleString('de-DE', {
            timeZone: 'Europe/Berlin',
            weekday: 'short', day: 'numeric', month: 'short', year: 'numeric'
        });
    
    return formattedDate;
};

const dateFnsLocales = {
    en: enUS,
    de: de,
  };

const getMonthLabel = (dateString, language) => {
    const locale = dateFnsLocales[language] || dateFnsLocales.en;
    const date = new Date(dateString);
    return format(date, 'MMM', { locale });
  }

export { GMTtoCET, FormatCET, getMonthLabel, timeAgo, handleDateInput, formatDateForBackend, isAtLeastMinutesInFuture };
